import { INITIALIZE_CONNEXION } from '../constants';
import axios from 'axios';
import { API_HOST } from '../config.env';
import _ from 'lodash';
import { getCookie, me } from '../helpers';
import { addBatchCustomData } from '../services/notifications';

const headers = { Accept: 'application/ld+json', 'content-type': 'application/json' };

export const initializeConnexion = () => {
    return dispatch => {

        // token can be passed as cookie or from url
        let token = getCookie('_ufa');

        if (!token) {
            const hash = window.location.hash.split('_ufa=');
            token = hash ? hash[1] : null;
        }

        if (sessionStorage.getItem('token_access')) {
            //installation recipient batch
            addBatchCustomData({ "ut.recipient": { "$add": [`user_${me().id}`] } });
            dispatch({ type: INITIALIZE_CONNEXION, payload: sessionStorage.getItem('token_access') });
        } else {
            return axios.post(`${API_HOST}/api/users/createFromSSO`, { token }, { headers })
                .then(response => {
                    const { email, ssoId } = response.data;
                    axios.post(`${API_HOST}/authentication_token`, { email, password: ssoId }, { headers })
                        .then(auth => {
                            sessionStorage.setItem('me', JSON.stringify(_.pick(response.data, ['@id', 'email', 'ssoId', 'firstname', 'lastname', 'nickname'])));
                            sessionStorage.setItem('token_access', auth.data.token);
                            //installation recipient batch
                            addBatchCustomData({ "ut.recipient": { "$add": [`user_${me().id}`] } });
                            dispatch({ type: INITIALIZE_CONNEXION, payload: auth.data.token });
                        })
                        .catch(() => dispatch({ type: INITIALIZE_CONNEXION, payload: -1 }));

                })
                .catch(() => dispatch({ type: INITIALIZE_CONNEXION, payload: -1 }));
        }
    }
}

export const refreshConnexion = () => {
    return dispatch => {
        sessionStorage.removeItem('token_access');
        sessionStorage.removeItem('me');
        dispatch(initializeConnexion());
    }
}